module.exports = __webpack_public_path__ + "img/3-4.e24a8660.jpg";